import React, { useEffect } from 'react';
import { UpsellHero } from '../components/upsell/UpsellHero';
import { OfferImpactSection } from '../components/upsell/OfferImpactSection';
import { Bonus1Section } from '../components/upsell/Bonus1Section';
import { Bonus2x1Section } from '../components/upsell/Bonus2x1Section';
import { DecisionSection } from '../components/upsell/DecisionSection';
import { TestimonialsSection } from '../components/upsell/TestimonialsSection';
import { UrgencySection } from '../components/upsell/UrgencySection';
import { PopNotifications } from '../components/upsell/PopNotifications';
export function UpsellPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full font-body text-text-dark selection:bg-sage/30 relative" data-id="element-388">
      {/* Fixed blurred background image behind all sections */}
      <div className="fixed inset-0 z-0 pointer-events-none" data-id="element-389">
        <img src="https://cdn.magicpatterns.com/uploads/muAyBqLc7bCQndZz9V3uJY/Portada_libro.png" alt="" className="w-full h-full object-cover scale-110 blur-xl" data-id="element-390" />
        <div className="absolute inset-0 bg-[#F2E8DA]/30" data-id="element-391"></div>
      </div>

      <div className="relative z-10" data-id="element-392">
        <UpsellHero data-id="element-393" />
        <OfferImpactSection data-id="element-394" />
        <section className="py-24 bg-[#EDE4D6]/50 backdrop-blur-[2px]" data-id="element-395">
          <div className="container mx-auto px-6 max-w-6xl" data-id="element-396">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch" data-id="element-397">
              <Bonus1Section data-id="element-398" />
              <Bonus2x1Section data-id="element-399" />
            </div>
            <div className="flex justify-center mt-8" data-id="element-400">
              <button onClick={() => {
              window.open('https://www.betterdailyguides.com/cart/51826786402606:1', '_blank');
            }} className="text-text-medium hover:text-text-dark text-sm underline underline-offset-4 transition-colors" data-id="element-401">
                No gracias, continuar sin bonos →
              </button>
            </div>
          </div>
        </section>
        <DecisionSection data-id="element-402" />
        <TestimonialsSection data-id="element-403" />
        <UrgencySection data-id="element-404" />
        <PopNotifications data-id="element-405" />
      </div>
    </div>;
}